export const fetcher = async <ReturnType>(...args: [RequestInfo, RequestInit?]): Promise<ReturnType> => {
  const response = await fetch(...args);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  try {
    return await response.json();
  } catch {
    throw new Error('Failed to parse JSON');
  }
};
